<template>
    <component :is="component" v-if="component"/>

</template>

<script>
import {defineAsyncComponent} from "vue";

export default {
    name: "AlarmEmptyLink",
    mixins: [],
    components: {},
    provide() {
        return {}
    },
    props: {
        emptyLayout: {},
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {
        component() {
            if (!this.emptyLayout) {
                return defineAsyncComponent(() => import('@/components/alarm/layout/empty/AlarmEmptyDefaultLayout.vue'))
            }
            return defineAsyncComponent(() => import(`@/components/alarm/layout/empty/${this.emptyLayout}.vue`))
        },
    },
    methods: {
    },
    watch: {},
}
</script>

<style scoped>

</style>
